import { create } from "zustand";

interface CashbackDialogStore {
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}

export const useCashbackDialogStore = create<CashbackDialogStore>((set) => ({
  isOpen: false,
  handleOpen: () => set({ isOpen: true }),
  handleClose: () => set({ isOpen: false }),
}));
